import React, { useEffect } from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useOrganizationUpdaterProvider } from '../../../context_providers/organization_context/OrganizationProvider';
import { useHistory } from 'react-router-dom';
import { useUserContext } from '../../../context_providers/user_context/UserProvider';
import GroupManagement from '../group_management/GroupManagement';
import Loading from '../../../components/loading/Loading';

export const UserManagement = ({ selectedGroup }) => {
  const { organization, configurations } = useOrganizationUpdaterProvider();
  const history = useHistory();
  const { userExists } = useUserContext();

  useEffect(() => {
    if (!userExists) {
      history.push('/');
    }
  }, [userExists, history]);

  return (
    <>
      <GroupManagement
        organization={organization}
        configurations={configurations}
        selectedGroup={selectedGroup}
      />
    </>
  );
};

export default withAuthenticationRequired(UserManagement, {
  onRedirecting: () => <Loading loadingText={'Loading...'} />,
});
